module.exports = __webpack_public_path__ + "img/wall.2fdb1ffb.png";